import script from "./EditOrientation.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditOrientation.vue?vue&type=script&setup=true&lang=ts"

import "./EditOrientation.vue?vue&type=style&index=0&id=85e5b7ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e5b7ce"]])

export default __exports__